/* eslint-disable react/display-name */
import * as React from 'react';

const StarFull = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Work-in-progress" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g id="Artboard" transform="translate(-9.000000, -26.000000)" fill="#807167" stroke="#807167">
        <polygon
          id="Star-Copy-13"
          points="16 36.5 11.8855032 38.663119 12.6713022 34.0815595 9.34260439 30.836881 13.9427516 30.1684405 16 26 18.0572484 30.1684405 22.6573956 30.836881 19.3286978 34.0815595 20.1144968 38.663119"
        />
      </g>
    </g>
  </svg>
);

export default StarFull;
